import React from 'react';
import { Box, Card, Title } from '@nimbus-ds/components';
import { BankAccountInactiveAlert, ErrorMessage } from 'commons/components';
import { useBankAccount } from 'commons/hooks';
import { BankAccountStatus } from 'commons/services/bankAccountService/bankAccountService';
import { useTranslationWithPrefix } from 'commons/utils';
import { maskAccountNumber } from 'commons/utils/cbu';
import { BankAccount, FiscalDocument } from '../../shared';
import PersonalDataMexicoSkeleton from './PersonalDataMexicoSkeleton';

function PersonalDataMexico() {
  const { t } = useTranslationWithPrefix('configuration.personalData');
  const bankAccount = useBankAccount(undefined, true);

  if (bankAccount.isLoading) {
    return <PersonalDataMexicoSkeleton />;
  }

  if (bankAccount.isError)
    return (
      <Card>
        <Card.Header>
          <Title as="h4">{t('cardTitle')}</Title>
        </Card.Header>
        <ErrorMessage />
      </Card>
    );

  const bankName = bankAccount.data.bankName;
  const beneficiaryName = bankAccount.data.holderName;
  const beneficiaryAccountNumber = bankAccount.data.accountNumber;
  const isRegistered = bankAccount.data.isRegistered;
  const fiscalNumber = bankAccount.data.fiscalDocument;
  const showInactiveAlert =
    isRegistered && bankAccount.data.status === BankAccountStatus.INACTIVE;

  return (
    <>
      {showInactiveAlert && (
        <BankAccountInactiveAlert title={t('inactiveAccountAlert.title')} />
      )}
      <Card>
        <Card.Header>
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Title as="h4">{t('cardTitle')}</Title>
          </Box>
        </Card.Header>
        <Box display="flex" flexDirection="column" alignItems="stretch" gap="6">
          <Box
            display="flex"
            flexDirection="column"
            alignItems="stretch"
            gap="4"
          >
            <FiscalDocument fiscalNumber={fiscalNumber} />
            <BankAccount
              isRegistered={isRegistered}
              bankName={bankName}
              beneficiaryName={beneficiaryName}
              beneficiaryAccountNumber={
                beneficiaryAccountNumber
                  ? maskAccountNumber(beneficiaryAccountNumber)
                  : ''
              }
            />
          </Box>
        </Box>
      </Card>
    </>
  );
}

PersonalDataMexico.displayName = 'PersonalDataMexico';
PersonalDataMexico.Skeleton = PersonalDataMexicoSkeleton;

export default PersonalDataMexico;
